import { css } from "@emotion/react";
import { colors, gutterSizes } from "../base/theme";

export const paginationCss = css`
    &.pagination {
        margin-bottom: 56px;

        .pagination-list {
            display: flex;
            list-style-type: none;
            justify-content: center;
            margin: 0;
            padding: 0;
        }

        .pagination-link {
            color: ${colors.blue};
            text-decoration: none;
            border-radius: 30px;
            min-width: 36px;
            height: 36px;
            line-height: 26px;
            position: relative;

            &:before {
                content: "";
                width: calc(100% - 20px);
                height: 1px;
                background: ${colors.blue};
                position: absolute;
                bottom: ${gutterSizes.small};
                left: 50%;
                transition: 0.2s ease;
                transform: translateX(-55%);
                opacity: 0;
            }

            &:hover {
                color: ${colors.blue};

                &:before {
                    opacity: 1;
                }
            }

            &:focus {
                color: ${colors.blue};
                border: 2px solid ${colors.gtallBlue};
                border-radius: 4px;
                outline: none;

                &:before {
                    width: calc(100% - 20px);
                }
            }

            &[disabled] {
                color: ${colors.blade};

                &:before {
                    opacity: 1;
                    background: ${colors.blade};
                }
            }

            &.pagination-link--previous {
                border-radius: 4px 0 0 4px;

                &:after {
                    right: 0;
                }
            }

            &.pagination-link--next {
                border-radius: 0 4px 4px 0;

                &:after {
                    left: 0;
                }
            }

            &.pagination-link--previous,
            &.pagination-link--next {
                border: 1px solid ${colors.paginationBorder};
                color: ${colors.bark80};
                background: white;
                padding: 0 ${gutterSizes.base};
                box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
                margin: 0 ${gutterSizes.small};
                transition: 0.3s ease;
                z-index: 1;

                &:before {
                    display: none;
                }

                &[disabled] {
                    pointer-events: none;
                    color: ${colors.paginationBorder};
                    border-color: ${colors.branch40};
                    background: ${colors.paginationDisabled};
                    box-shadow: none;
                    opacity: 0.6;
                }

                &:hover,
                &:focus {
                    background: ${colors.paginationDisabled};
                    color: ${colors.bark80};
                }
            }
        }

        .pagination-icon {
            font-size: 13px;
        }

        .pagination-eclipse {
            width: 36px;
            height: 36px;
            line-height: 26px;
            text-align: center;
            padding: ${gutterSizes.small} 0;
            box-sizing: border-box;
            color: ${colors.paginationLightGrey};
        }
    }
`;
